import { AbstractControl, ValidatorFn } from '@angular/forms';

export function urlValidator(c: AbstractControl): {[key: string]: boolean} | null {
  const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  if (!pattern.test(c.value)) {
    return {
      'url': false
    };
  }
}

// Example of how to use a validator that needs arguments
/* example usage:
  this.form = this.formbuilder.group({
    age: [20, rangeValidator(18, 65)]
  })
*/
export function rangeValidator(min: number, max: number): ValidatorFn {
  return (c: AbstractControl): {[key: string]: boolean} | null => {
     const value = +c.value;
     if (value < min || value > max) {
       return { 'range': false };
     }
   };
}
